import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';

/** Resolves the single logged-in application role used by entity-permission APIs. */
@Injectable({ providedIn: 'root' })
export class EntityPermissionRoleService {
  constructor(private readonly keycloakService: KeycloakService) {}

  getLoggedInRole(rolePriority: string[] = []): string {
    const token = this.keycloakService.getKeycloakInstance()?.tokenParsed as any;
    const realmRoles = Array.isArray(token?.realm_access?.roles)
      ? token.realm_access.roles.map((role: unknown) => String(role).trim())
      : [];
    let keycloakRoles: string[] = [];
    try {
      keycloakRoles = (this.keycloakService.getUserRoles(true) || [])
        .map((role) => String(role).trim());
    } catch {
      keycloakRoles = [];
    }

    const roles = [...realmRoles, ...keycloakRoles]
      .filter(Boolean)
      .filter((role, index, all) =>
        all.findIndex((item) => item.toLowerCase() === role.toLowerCase()) === index,
      );
    const preferredRole = rolePriority
      .map((priorityRole) =>
        roles.find((role) => role.toLowerCase() === priorityRole.toLowerCase()),
      )
      .find((role): role is string => !!role);

    const technicalRoles = new Set([
      'offline_access',
      'uma_authorization',
      'manage-account',
      'manage-account-links',
      'view-profile',
    ]);
    const usableRoles = roles.filter((role) => !technicalRoles.has(role.toLowerCase()));
    const applicationRole = usableRoles.find(
      (role) => !role.toLowerCase().startsWith('default-roles-'),
    );
    const selectedRole = preferredRole || applicationRole || usableRoles[0] || '';

    console.info('[ENTITY_PERMISSION_LOGGED_IN_ROLE]', {
      realmRoles,
      keycloakRoles,
      usableRoles,
      rolePriority,
      selectedRole,
    });

    return selectedRole;
  }
}
